import api from '../services/api';
export const ContactModel = {
  submit: (formData) => api.sendContact(formData)
};
